import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import Stars from "MODULES/shared/components/Stars/Stars";
import {
  AUTO_ADJUST_SRP_EXCLUSION,
  BIO_HAZMAT,
  CAGE,
  CATALOG_URL,
  CLASSIFIED_MEMO,
  COUNTRY_OF_MFG,
  DESCRIPTION,
  DOM_LIFE_YEARS,
  DOM_SENSITIVE,
  ECCN,
  ESD,
  EXPORT_COMPLIANCE,
  HAZMAT,
  HTSUS_CODE,
  IMPORTANT_MEMO,
  LLP,
  MANUFACTURER,
  MASTER_PART_LOCK,
  MLP,
  MILITARY,
  PART_NUMBER,
  PASS_FAIL,
  PERMANENT_EXTERNAL_NOTE_FOR_OQ,
  PURCHASED_AT,
  SHELF_LIFE,
  SPECIAL_CONTAINER_FEE,
  SPECIAL_CONTAINER_REQ,
  SCHEDULE_B_OR_HT_CODE,
  TOOLING_PART_TYPE,
  UNITED_NATIONS_CODE,
  WARRANTY_OVERRIDE,
  TOTAL_CYCLES,
  TOTAL_HOURS,
  UPDATED_AT
} from "MODULES/parts/constants";
import { useCurrentUser } from "APP_ROOT/hooks";
import pojo from "LIB/pojos";
import Form from "./Form";

export default function EditPart({ open, close, part, toggleMergePartModal }) {
  const initialValues = pojo(part).pick(
    AUTO_ADJUST_SRP_EXCLUSION,
    BIO_HAZMAT,
    CAGE,
    CATALOG_URL,
    CLASSIFIED_MEMO,
    COUNTRY_OF_MFG,
    DESCRIPTION,
    DOM_SENSITIVE,
    DOM_LIFE_YEARS,
    ECCN,
    ESD,
    EXPORT_COMPLIANCE,
    HAZMAT,
    HTSUS_CODE,
    IMPORTANT_MEMO,
    LLP,
    MANUFACTURER,
    MASTER_PART_LOCK,
    MLP,
    MILITARY,
    PART_NUMBER,
    PASS_FAIL,
    PERMANENT_EXTERNAL_NOTE_FOR_OQ,
    PURCHASED_AT,
    SCHEDULE_B_OR_HT_CODE,
    SHELF_LIFE,
    SPECIAL_CONTAINER_FEE,
    SPECIAL_CONTAINER_REQ,
    TOOLING_PART_TYPE,
    TOTAL_CYCLES,
    TOTAL_HOURS,
    UNITED_NATIONS_CODE,
    UPDATED_AT,
    WARRANTY_OVERRIDE
  );

  initialValues.locations = useCurrentUser().locations.map(l => {
    const account = part.quickbooks_account[l.id] || {};

    return { id: l.id, quickbooks_account: account };
  });

  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4 className="modal-title">Edit Part Details</h4>
          <Stars
            size="fa-lg"
            tierType={part.tier_type}
            style={{ marginRight: 15 }}
            disabled={false}
          />
        </div>
      </Header>
      <Form
        close={close}
        enableReinitialize
        initialValues={initialValues}
        part={part}
        toggleMergePartModal={toggleMergePartModal}
      />
    </Modal>
  );
}

EditPart.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  part: PropTypes.shape({}),
  toggleMergePartModal: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/EditPart/EditPart.jsx